import { ActivateLOC, ApplyCoupon, ApplyCredit, ApplyWallet, CreateOrder, PaymentSummary } from "@/types/payment";
import axios from "axios";
const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

export const cashfreeService = {
  async initiatePayment(userID: string, amount: number) {
    const response = await axios.get(`${API_BASE_URL}/payment/${userID}/${amount}`);
    return response.data;
  },

  async checkPaymentStatus(linkID: string) {
    const response = await axios.get(`${API_BASE_URL}/payment/status/${linkID}`);
    return response.data;
  },
  async fetchCoupons() {
    const response = await axios.get(`${API_BASE_URL}/coupon/fetch`);
    return response.data;
  },

  async validateCoupon(userID: string | null, couponCode: string) {
    const response = await axios.get(`${API_BASE_URL}/coupons/validate/${userID}/${couponCode}`);
    return response.data;
  },

  async fetchAvailableCredit(userID: string | null) {
    const response = await axios.get(`${API_BASE_URL}/credit/available/${userID}`);
    return response.data;
  },

  async fetchCreditPage(userID: string | null) {
    const response = await axios.get(`${API_BASE_URL}/credit/page/${userID}`);
    return response.data;
  },
  async fetchWalletBalance(userID: string | null) {
    const response = await axios.get(`${API_BASE_URL}/wallet/balance/${userID}`);
    return response.data;
  },
  async fetchWallet(userID: string | null) {
    const response = await axios.get(`${API_BASE_URL}/wallet/${userID}`);
    return response.data;
  },
  async applyCoupon(data: ApplyCoupon) {
    const response = await axios.post(`${API_BASE_URL}/coupon/apply`, data);
    return response.data;
  },
  async applyWallet(data: ApplyWallet) {
    const response = await axios.post(`${API_BASE_URL}/wallet/use`, data);
    return response.data;
  },
  async applyCredit(data: ApplyCredit) {
    const response = await axios.post(`${API_BASE_URL}/credit/pay`, data);
    return response.data;
  },
  async createOrder(data: CreateOrder) {
    const response = await axios.post(`${API_BASE_URL}/order/create`, data);
    return response.data;
  },
  async activateLOC(data: ActivateLOC) {
    const response = await axios.post(`${API_BASE_URL}/credit/add`, data);
    return response.data;
  },
  async updatePaymentStatusByAdmin(transactionId: string | null) {
    const response = await axios.get(`${API_BASE_URL}/update/payment/${transactionId}`);
    return response.data;
  },
  async postPaymentSummary(data: PaymentSummary) {
    const response = await axios.post(`${API_BASE_URL}/cart/payment/summary`, data);
    return response.data;
  },
  async getPaymentSummary(phoneNumber: string | null) {
    const response = await axios.get(`${API_BASE_URL}/cart/payment/summary/${phoneNumber}`);
    return response.data;
  },
};